// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__365An","footer":"Form_footer__2dYU-"};